import { render, staticRenderFns } from "./EditCallTagDialog.vue?vue&type=template&id=92820408&scoped=true"
import script from "./EditCallTagDialog.vue?vue&type=script&lang=js"
export * from "./EditCallTagDialog.vue?vue&type=script&lang=js"
import style0 from "./EditCallTagDialog.vue?vue&type=style&index=0&id=92820408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92820408",
  null
  
)

export default component.exports